var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"breadcrumbs"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('h2',[_vm._v(_vm._s(_vm.pagename))]),_c('ol',[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_c('li',[_vm._v(_vm._s(_vm.pagename))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }